import {
  AsyncThunk,
  createAsyncThunk,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import type { RootState } from './store';
import { getAuthors } from '../api/api';
import { AxiosError } from 'axios';
import { isEmptyAuthorValue } from '../utilities/AuthorUtilities';

export interface AuthorsState {
  authors: string[];
  loading: boolean;
  error: AxiosError | null;
}

const initialState: AuthorsState = {
  authors: [],
  loading: false,
  error: null,
};

export const initAuthorsAsync: AsyncThunk<string[], void, object> =
  createAsyncThunk('authors/initAuthorsAsync', getAuthors);

const authorsSlice = createSlice({
  initialState,
  name: 'authors',
  reducers: {
    setAuthors(state, action: PayloadAction<string[]>) {
      state.authors = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initAuthorsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(initAuthorsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.authors = action.payload;
      })
      .addCase(initAuthorsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error as AxiosError;
      });
  },
});

export const { setAuthors } = authorsSlice.actions;

export const selectAllAuthors = (state: RootState) => {
  return state.authors.authors;
};

export const selectAuthors = createSelector([selectAllAuthors], (authors) =>
  authors.filter((author: string) => !isEmptyAuthorValue(author)),
);

export default authorsSlice.reducer;
